import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import {
  FormCheckbox,
  FormDropDownList,
  FormInput,
  FormMultiSelect,
  FormNumericTextBox,
  FormTextArea,
} from 'commons/forms/form';
import { required } from 'commons/forms/validators';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import CustomModal from 'commons/modal/CustomModal';
import * as dates from 'commons/models/dates';
import React, { useState } from 'react';
import LoaderContainer from 'commons/container/LoaderContainer';
import { useGetBannieresQuery, useGetDivisionsQuery, useGetMediasQuery } from '../../../../redux/api/cache';

export default function CreateMessagesModal(props) {
  const { data: divisionsDropDown, isLoading: divionsLoading } = useGetDivisionsQuery();
  const { data: mediasDropDown, isLoading: mediasLoading } = useGetMediasQuery();
  const { data: bannieresDropDown, isLoading: bannieresLoading } = useGetBannieresQuery();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const handleSubmit = (dataItem) => {
    let media = mediasDropDown.data.find((item) => item.media_cd === dataItem.media)
      .media_cd;
    let divisions = dataItem.division
      .map(
        (div) =>
          divisionsDropDown.data?.find((store) => store?.div_nom === div).div_num
      )
      .join(',');
    let banner = bannieresDropDown.data?.find(
      (item) => item.maggrp_descr === dataItem.banner
    )?.maggrp_cd;

    props.create({
      media_cd: media,
      maggrp_cd: banner,
      div_num_lst: divisions,
      ann_descr: dataItem.title,
      ann_duree: dataItem.dure,
      ann_intemp: dataItem.intemporelle,
      ann_retire: dataItem.retire,
      ann_raison_retrait: dataItem.raison,
      ann_note: dataItem.note,
      ann_porte_parole: dataItem.porteparole,
      ann_plan: dataItem.plan,
      ann_seq: props.selectedRow?.ann_seq,
      ann_num: props.selectedRow?.ann_num,
    });

    props.toggleDialog();
  };

  const allDivision = (div_num_lst) => {
    if (
      div_num_lst !== undefined &&
      divisionsDropDown.data.length > 0 &&
      div_num_lst.split(',') !== ''
    ) {
      let divisions = div_num_lst.split(',');
      return divisions.map(
        (id) =>
          divisionsDropDown.data.find((div) => div.div_num === parseFloat(id))
            ?.div_nom
      );
    }
    return [];
  };

  const titreValidator = (e) => required(e, 'Titre');
  const divisionValidator = (e) => required(e, 'Division');
  const banniereValidator = (e) => required(e, 'Bannière');
  const mediaValidator = (e) => required(e, 'Média');
  const dureeValidator = (e) => required(e, 'Durée');

  return (
    <div>
      <CustomModal
        width={'50%'}
        title="Annonce"
        onClose={props.toggleDialog}
        body={<>
          {(mediasLoading || bannieresLoading || divionsLoading) && <LoaderContainer style={{ height: '100px' }} />}
          {!mediasLoading && !divionsLoading && !bannieresLoading && (
            <Form
              initialValues={{
                media: mediasDropDown.data.find(
                  (item) => item.media_cd === props.selectedRow?.media_cd
                )?.media_cd,
                division: allDivision(props.selectedRow?.div_num_lst).filter(
                  (x) => x !== undefined
                ),
                banner: bannieresDropDown.data?.find(
                  (item) => item.maggrp_cd === props.selectedRow?.maggrp_cd
                )?.maggrp_descr,
                title: props.selectedRow?.ann_descr,
                dure:
                  props.selectedRow?.ann_duree === undefined
                    ? null
                    : parseFloat(props.selectedRow?.ann_duree),
                intemporelle: props.selectedRow?.ann_intemp,
                retire: props.selectedRow?.ann_retire,
                raison: props.selectedRow?.ann_raison_retrait,
                note: props.selectedRow?.ann_note,
                porteparole: props.selectedRow?.ann_porte_parole,
                plan: props.selectedRow?.ann_plan,
                dateVigueur:
                  props.selectedRow !== undefined
                    ? dates.addDays(props.selectedRow?.campr_dt_limite, 1)
                    : null,
                date:
                  props.selectedRow !== undefined
                    ? dates.addDays(props.selectedRow?.campr_dt_fin, 1)
                    : null,
                number: props.selectedRow?.ann_num,
              }}
              onSubmit={handleSubmit}
              render={(formRenderProps) => (
                <FormElement>
                  <fieldset className={'k-form-fieldset'}>
                    <div className="row">
                      <div className="col-md-2">
                        <Field
                          disabled
                          id={'number'}
                          name={'number'}
                          label={'Numéro'}
                          component={FormInput}
                          wrapperStyle={{
                            minWidth: '5rem',
                          }} />
                      </div>
                      <div className="col-md-10">
                        <Field
                          id={'title'}
                          name={'title'}
                          label={'Titre'}
                          component={FormInput}
                          validator={titreValidator}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-9">
                        <Field
                          id={'Division'}
                          name={'division'}
                          label={'Division'}
                          component={FormMultiSelect}
                          data={divisionsDropDown.data?.map((item) => item.div_nom)}
                          validator={divisionValidator} />
                      </div>
                      <div className="col-md-2">
                        <Field
                          id={'retire'}
                          name={'retire'}
                          label={`Retiré`}
                          component={FormCheckbox}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <Field
                          id={'banner'}
                          name={'banner'}
                          label={'Bannière'}
                          component={FormDropDownList}
                          data={bannieresDropDown.data?.map((item) => item.maggrp_descr)}
                          validator={banniereValidator}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                      <div className="col-md-4">
                        <Field
                          id={'media'}
                          name={'media'}
                          label={'Média'}
                          data={mediasDropDown.data?.map((item) => item.media_cd)}
                          component={FormDropDownList}
                          validator={mediaValidator}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                      <div className="col-md-2">
                        <Field
                          id={'intemporelle'}
                          name={'intemporelle'}
                          label={`Intemporelle`}
                          component={FormCheckbox}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-9">
                        <Field
                          optional={true}
                          id={'raison'}
                          name={'raison'}
                          label={'Raison'}
                          component={FormInput} />
                      </div>
                      <div className="col-md-3">
                        <Field
                          id={'dure'}
                          name={'dure'}
                          label={'Durée'}
                          format={'n0'}
                          component={FormNumericTextBox}
                          validator={dureeValidator}
                          wrapperStyle={{
                            minWidth: '10rem',
                          }} />
                      </div>
                    </div>
                    <Field
                      rows={6}
                      id={'note'}
                      name={'note'}
                      label={'Note'}
                      optional={true}
                      visited="false"
                      component={FormTextArea}
                      wrapperStyle={{ minWidth: '10rem' }}
                    />
                    <Field
                      id={'porteparole'}
                      name={'porteparole'}
                      label={'Porte-parole (s)'}
                      optional={true}
                      visited="false"
                      component={FormTextArea}
                      wrapperStyle={{ minWidth: '10rem' }} />
                    <Field
                      id={'plan'}
                      name={'plan'}
                      label={'Plan (s)'}
                      optional={true}
                      visited="false"
                      component={FormTextArea}
                      wrapperStyle={{ minWidth: '10rem' }} />
                    <div className="k-form-buttons">
                      <Button
                        type={'submit'}
                        className="blueButton"
                        disabled={!formRenderProps.allowSubmit}>
                        Enregistrer
                      </Button>
                      <Button onClick={formRenderProps.onFormReset} className="whiteButton" style={{ width: '100px' }}>
                        Réinitialiser
                      </Button>
                    </div>
                  </fieldset>
                </FormElement>
              )}
            />
          )}</>}
      />
      {deleteModalVisible && (
        <ConfirmationModal
          text={`Supprimer annoce # ${props.selectedRow.ann_seq}`}
          onClose={() => {
            setDeleteModalVisible(false);
          }}
          onConfirm={() => {
            setDeleteModalVisible(false);
            props.toggleDialog();
            props.remove();
          }}
        />
      )}
    </div>
  );
}

CreateMessagesModal.propTypes = {
  create: PropTypes.func,
  remove: PropTypes.func,
  selectedRow: PropTypes.shape({
    ann_descr: PropTypes.any,
    ann_duree: PropTypes.any,
    ann_intemp: PropTypes.string,
    ann_note: PropTypes.any,
    ann_num: PropTypes.any,
    ann_plan: PropTypes.any,
    ann_porte_parole: PropTypes.any,
    ann_raison_retrait: PropTypes.any,
    ann_retire: PropTypes.string,
    ann_seq: PropTypes.any,
    campr_dt_fin: PropTypes.any,
    campr_dt_limite: PropTypes.any,
    div_num_lst: PropTypes.any,
    maggrp_cd: PropTypes.any,
    media_cd: PropTypes.any,
  }),
  toggleDialog: PropTypes.func,
};
